export enum DocumentSaveStatus {
  NOT_SAVED,
  SAVED,
  SAVING,
}
